// extracted by mini-css-extract-plugin
export default {"carouselSlideContainer":"videoContentCard_carouselSlideContainer__jBhQd","carouselSlide":"videoContentCard_carouselSlide__OS957"};